module.exports = __webpack_public_path__ + "static/media/eye.f3b4576a.svg";